<template>
  <div style="border: 0px solid black; width:100%;display:block;">
    <div class="welcome" style="border: 0px solid red;">
      <row style="border:0px solid green;display: contents;width:100%;">
        <div class="box box-success">
          <div class="box-header with-border">
            <h3 class="box-title">{{ $t("templateNotification.info") }}</h3>
          </div>
          <div class="box-body">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="">{{ $t("templateNotification.name") }}</label>
                    <input
                      :placeholder="$t('templateNotification.name')"
                      type="text"
                      class="form-control"
                      v-model="templateData.name"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="">{{
                      $t("templateNotification.chooseValue")
                    }}</label>
                    <div class="input-group">
                      <select
                        name=""
                        id=""
                        class="form-control selectTemplateField"
                        v-model="templateFieldSelect"
                      >
                        <option
                          v-for="(item, index) in templateFieldList"
                          :key="item + index"
                          :value="item"
                          >{{ item.name }}</option
                        >
                      </select>
                      <span
                        id="insertTemplateField"
                        class="input-group-addon cursor-pointer"
                        @click="onInsertTemplateField(templateFieldSelect)"
                        ><i class="glyphicon glyphicon-pencil"></i
                      ></span>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="">{{
                      $t("templateNotification.chooseTemplateDefault")
                    }}</label>
                    <div class="input-group">
                      <select
                        name=""
                        id=""
                        class="form-control"
                        v-model="templateNotificationDefaultSelect"
                      >
                        <option
                          v-for="(item, index) in templateNotificationDefault"
                          :key="item + index"
                          :value="item"
                          >{{ item.name }}</option
                        >
                      </select>
                      <span
                        class="input-group-addon cursor-pointer"
                        @click="
                          onViewTemplateDefault(
                            templateNotificationDefaultSelect
                          )
                        "
                        ><i class="glyphicon glyphicon-eye-open"></i
                      ></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="box-header with-border">
            <h3 class="box-title">
              {{ $t("sidebar.projectsettings.configTemplateNotification") }}
            </h3>
          </div>
          <div class="box-body">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="">{{
                      $t("templateNotification.templateTitle")
                    }}</label>
                    <input
                      :placeholder="$t('templateNotification.templateTitle')"
                      type="text"
                      class="form-control"
                      v-model="templateData.templateTitle"
                    />
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="">{{
                      $t("templateNotification.templateContent")
                    }}</label>
                    <textarea
                      id="templateNotificationContent"
                      :placeholder="$t('templateNotification.templateContent')"
                      class="md-textarea form-control AddMessage"
                      rows="5"
                      v-model="templateData.templateContent"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="box-footer with-border">
            <button
              class="btn btn-success btn-sm pull-right"
              style="margin-left: 6px;"
              @click="onSaveTemplate"
            >
              <i class="glyphicon glyphicon-floppy-saved"></i>
              {{ $t("common.save") }}
            </button>
            <button
              class="btn btn-danger btn-sm pull-left"
              style="margin-left: 6px;"
              @click="onCallbackTemplate"
            >
              <i class="glyphicon glyphicon-remove"></i>
              {{ $t("common.close") }}
            </button>
          </div>
        </div>
      </row>
    </div>
    <!--  -->
    <div
      class="modal fade"
      data-backdrop="static"
      id="modal-view-template-default"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">{{ $t("common.add_user_to_project") }}</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12 col-md-12 col-lg-12">
                <div class="form-group">
                  <label for="">{{
                    $t("templateNotification.templateTitle")
                  }}</label>
                  <p>
                    {{
                      templateNotificationDefaultSelect &&
                        templateNotificationDefaultSelect.title
                    }}
                  </p>
                </div>
              </div>
              <div class="col-sm-12 col-md-12 col-lg-12">
                <div class="form-group">
                  <label for="">{{
                    $t("templateNotification.templateContent")
                  }}</label>
                  <p>
                    {{
                      templateNotificationDefaultSelect &&
                        templateNotificationDefaultSelect.content
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              :class="'btn btn-primary btn-sm pull-right'"
              @click="onConfirmUseTemplate"
            >
              {{ $t("common.confirm") }}
            </button>
            <button
              type="button"
              data-dismiss="modal"
              class="btn btn-warning btn-sm pull-left"
            >
              {{ $t("common.back") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import utils from "@/lib/utils";
import LTECoreAlert from "@/components/LTESnackBar.vue";
export default {
  components: {
    "lte-core-alert": LTECoreAlert
  },
  data: () => ({
    templateFieldList: [],
    templateFieldSelect: null,
    templateNotificationDefault: [],
    templateNotificationDefaultSelect: null,
    templateData: {
      id: 0,
      name: null,
      templateTitle: null,
      templateContent: null
    }
  }),
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR"
    ])
  },
  methods: {
    onCallbackTemplate: function() {
      let categoryId = this.$route.params.categoryId;
      this.$router.push({
        name: "TemplateNotification",
        params: {
          categoryId: categoryId
        }
      });
    },
    getFieldNotificationByCategory: function() {
      let categoryId = this.$route.params.categoryId;
      let filter = {
        params: {
          categoryId: categoryId
        }
      };
      this.GET_FIELD_NOTIFICATION_BY_CATEGORY(filter).then(
        function(res) {
          this.templateFieldList = [];
          let data = res.data;
          data.forEach(v => {
            let item = {
              id: v.id,
              name: v.name,
              value: v.value
            };
            this.templateFieldList.push(item);
          });
        }.bind(this)
      );
    },
    onInsertTemplateField: function(data) {
      if (data) {
        var currentVal = $("textarea").val();
        $("textarea.AddMessage").val(currentVal + data.value);
      }
    },
    getTemplateNotificationDefault: function() {
      let categoryId = this.$route.params.categoryId;
      let filter = {
        params: {
          categoryId: categoryId
        }
      };
      this.GET_TEMPLATE_NOTIFICATION_DEFAULT(filter).then(
        function(res) {
          this.templateNotificationDefault = [];
          let data = res.data;
          data.forEach(v => {
            let item = {
              id: v.id,
              name: v.name,
              title: v.title,
              content: v.content
            };
            this.templateNotificationDefault.push(item);
          });
        }.bind(this)
      );
    },
    onViewTemplateDefault: function() {
      $("#modal-view-template-default").modal("show");
    },
    onConfirmUseTemplate: function() {
      $("#modal-view-template-default").modal("hide");
      if (this.templateNotificationDefaultSelect) {
        this.templateData.templateTitle = this.templateNotificationDefaultSelect.title;
        this.templateData.templateContent = this.templateNotificationDefaultSelect.content;
      }
    },
    validateTemplate: function() {
      let validateResults = "OK";
      for (let key in this.templateData) {
        if (utils.isEmptyString(this.templateData[key])) {
          validateResults = this.$t("templateNotification." + key);
          break;
        }
      }
      return validateResults;
    },
    onSaveTemplate: function() {
      let result = this.validateTemplate();
      let categoryId = this.$route.params.categoryId;
      if (result === "OK") {
        let data = {
          id: this.templateData.id,
          name: this.templateData.name,
          title: this.templateData.templateTitle,
          content: this.templateData.templateContent,
          categoryId: categoryId
        };
        if (this.templateData.id === 0) {
          this.CREATE_TEMPLATE_NOTIFICATION(data)
            .then(
              function() {
                this.onCallbackTemplate();
              }.bind(this)
            )
            .catch(
              function(error) {
                let message = error.response.data.message;
                this.showError(message);
              }.bind(this)
            );
        } else {
          this.UPDATE_TEMPLATE_NOTIFICATION(data)
            .then(
              function() {
                this.onCallbackTemplate();
              }.bind(this)
            )
            .catch(
              function(error) {
                let message = error.response.data.message;
                this.showError(message);
              }.bind(this)
            );
        }
      } else {
        this.showError(result);
      }
    },
    showError: function(msg) {
      this.ON_SHOW_TOAST({
        message: this.$t(msg),
        styleType: "danger"
      });
    },
    ...mapActions([
      "ON_SHOW_TOAST",
      "GET_FIELD_NOTIFICATION_BY_CATEGORY",
      "GET_TEMPLATE_NOTIFICATION_DEFAULT",
      "CREATE_TEMPLATE_NOTIFICATION",
      "UPDATE_TEMPLATE_NOTIFICATION",
      "GET_TEMPLATE_NOTIFICATION_DETAIL"
    ])
  },
  mounted() {},
  created() {
    this.getFieldNotificationByCategory();
    this.getTemplateNotificationDefault();
    let id = this.$route.params.id;
    if (id !== 0) {
      this.GET_TEMPLATE_NOTIFICATION_DETAIL({ id: id }).then(
        function(res) {
          this.templateData.id = res.id;
          this.templateData.name = res.name;
          this.templateData.templateTitle = res.title;
          this.templateData.templateContent = res.content;
        }.bind(this)
      );
    }
  }
};
</script>
<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/Notification/TemplateNotificationDetail.vue